import React from "react";
import "./appLink.scss";
import { connect } from "react-redux";
import { getSocial } from "../../../actions/home/socialAction";
import { isIOS, isAndroid, isTablet } from "react-device-detect";
import Appleplaystoreicon from "../appLinks/img/apple.webp"
import Androidplaystoreicon from "../appLinks/img/gplay.webp"

const AppLinker = ({ social }) => {
  return (
    <>
      {social?.message?.app && (
        <div className="app-link-btn">
          {social?.message?.app?.ios && !isAndroid && !isTablet && (
            // <button className="">
              <a
                href={`${social.message.app.ios}`}
                target="_blank"
                rel="apple store"
              >
                <img src={Appleplaystoreicon} className="img" alt="Apple Play" width="100" height="100" />
              </a>
            // </button>
          )}
          {social?.message?.app?.android && !isIOS && (
            // <button className="">
              <a
                href={`${social.message.app.android}`}
                target="_blank"
                rel="play store"
              >
                <img src={Androidplaystoreicon} className="img" alt="Google Play" width="100" height="100" />
              </a>
            // </button>
          )}
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  social: state.social.response,
});

const mapDispatchToProps = {
  getSocial,
};

export default connect(mapStateToProps, mapDispatchToProps)(AppLinker);
